export default __webpack_public_path__ + "static/media/BCN.797852a1.jpeg";